import React, { useEffect } from 'react'
import CustomDialog from '../../../../../components/stateless/dialog/CustomDialog'
import RichTextEditor from '../../../../../components/stateful/richTextEditor/RichTextEditor'
import ClickableZone from '../../../../../components/stateless/clickableZone/ClickableZone'
import HtmlRender from '../../../../../components/stateless/htmlRender/HtmlRender'
import { Skeleton } from '@progress/kendo-react-indicators'
import { RuleSearch } from '../../../../../components/stateful/ruleSearch/RuleSearch'
import { useRulesCmsController } from './RulesCmsController'

const Search = () => {

  const {
    // functions
    onSave,
    toggleCmsEdit,
    handleCmsItemClick,
    getAllCmsItems,
    // state
    cmsValues,
    infoCmsItem,
    cmsText,
    cmsTitle,
    editCmsOpen,
    isAdmin,
  } = useRulesCmsController();

  useEffect(() => {
    if (cmsValues.length < 1) {
      getAllCmsItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <>
        <CustomDialog
          open={editCmsOpen}
          hideButtons
          toggleDialog={toggleCmsEdit}
          cancelAction={toggleCmsEdit}
          title={`Edit ${cmsTitle}`}
          size='large'
        >
          <RichTextEditor content={cmsText ?? ''} height={'40vh'} onSave={onSave}></RichTextEditor>
        </CustomDialog>
        {infoCmsItem ? (
          <div className="info-text">
            <ClickableZone onClick={() => handleCmsItemClick(infoCmsItem.id ?? -1)} active={isAdmin}>
              <HtmlRender value={infoCmsItem.cmsItemValue ?? ""} className='' />
            </ClickableZone>
          </div>
        ) : (
          <div className="info-text">
            <Skeleton shape={'text'} style={{ width: '0%' }} />
            <Skeleton shape={'text'} style={{ width: '70%' }} />
            <Skeleton shape={'text'} style={{ width: '80%' }} />
            <Skeleton shape={'text'} style={{ width: '80%' }} />
            <Skeleton shape={'text'} style={{ width: '80%' }} />
          </div>
        )}
        <RuleSearch id={''} />
      </>
    </>
  )
}

export default Search